import { useParams, useNavigate } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import EditAstronMembersForm from "../../../components/apps/astronmembers/EditAstronMembersForm";

export default function EditAstronMembers() {
    const navigate = useNavigate();
    const { astronmembersId } = useParams<{ astronmembersId: string }>();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/astronmembers`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Editar Integração AstronMembers"
                description="Editar integração AstronMembers"
            />
            <PageBreadcrumb
                pageTitle="Editar Integração AstronMembers"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditAstronMembersForm
                    astronmembersId={astronmembersId}
                    onSuccess={() => {
                        // Redirecionar para a página de AstronMembers
                        navigate(`/apps/astronmembers`);
                    }}
                    onError={(error: any) => {
                        console.error("Erro ao editar integração AstronMembers:", error);
                    }}
                />
            </div>
        </>
    );
}
